import React from 'react';
import { Link } from '@reach/router';

const footer= () => (
  <footer className="footer-light">
           
        </footer>
);
export default footer;